import React from 'react';
import { SOURCE_URL } from '../../../config';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import { useInView } from 'react-intersection-observer';
import { animationClass, animationStyle } from '../../../utils/FadeInEffect';

interface SupportTwoColumnsLayoutProps {
    element: any
}

const SupportTwoColumnsLayout: React.FC<SupportTwoColumnsLayoutProps> = (element) => {
  const { ref, inView } = useInView({
        threshold: 0.3,
        triggerOnce: true,
    });

    return (
      <>
      <div className="container-fluid two-column-layout">
        <div className="row spacer-top">
            <div ref={ref} className={"col-md-6 mb-md-0 mb-5 " + (element?.element?.ImagePosition === "Left"? "order-1 " + animationClass(inView, "left"): "order-2 " + animationClass(inView, "right"))} style={element?.element?.ImagePosition == "Left" ? animationStyle(inView,'left') : animationStyle(inView,'right')}>
              <img src={SOURCE_URL + element?.element?.Image?.data?.attributes?.url} className="img-fluid mx-auto d-block" alt="" />
            </div>
            <div ref={ref} className={"col-md-6 two-column-desc " + (element?.element?.ImagePosition == "Left" ? "order-2 "  + animationClass(inView, 'right') : "order-1 "+ animationClass(inView, 'left'))} style={element?.element?.ImagePosition == "Left" ? animationStyle(inView,'right'): animationStyle(inView,'left')}>
              <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{element?.element?.Description}</ReactMarkdown>
              {element?.element?.ButtonLink ? 
                <a href={element?.element?.ButtonLink} target={element?.element?.OpenLinkInANewTab ? "_blank" : ""} className="default-btn two-column-desc-btn">{element?.element?.ButtonLinkText}</a>
              :<></>}
            </div>
        </div>
      </div>
      </>
    );
};

export default SupportTwoColumnsLayout;